var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUsers = function SvgUsers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.833 9.167a3.167 3.167 0 1 0 6.333 0 3.167 3.167 0 0 0-6.333 0zm7.82 2.623a2.499 2.499 0 0 1 4.077-2.724 2.5 2.5 0 1 1-4.077 2.724zm.601 2.282A3.967 3.967 0 0 1 16 13.667a4 4 0 0 1 4 4 .333.333 0 0 1-.333.333h-4.334a.333.333 0 0 1-.333-.333 5.957 5.957 0 0 0-.883-3.121.332.332 0 0 1 .137-.474zm-1.718.06A5 5 0 0 1 14 17.666a.333.333 0 0 1-.333.333H4.333A.333.333 0 0 1 4 17.667a5 5 0 0 1 8.536-3.536z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "users.6e4ca37b6c61129f48650ac6ab92f557.svg";